/**
 * Utility functions for name formatting
 */

/**
 * Capitalizes the first letter of each word in a name
 * Handles special cases like "Mc", "O'", "De", etc.
 * @param {string} name - The name to capitalize
 * @returns {string} The capitalized name
 */
export const capitalizeName = (name) => {
  if (!name || typeof name !== 'string') {
    return '';
  }

  const trimmed = name.trim();
  if (!trimmed) {
    return '';
  }

  return trimmed
    .split(/\s+/)
    .map(word => {
      if (!word) return '';
      
      // Handle special prefixes (Mc, Mac, O', De, etc.)
      const specialPrefixes = /^(Mc|Mac|O'|De|La|Le|Van|Von|Del|Della|Di|Da|El|Le|Les|Los|Las|St|Saint|San|Santa|Santo)$/i;
      const match = word.match(specialPrefixes);
      
      if (match) {
        const prefix = match[0];
        const rest = word.substring(prefix.length);
        return prefix.charAt(0).toUpperCase() + prefix.slice(1).toLowerCase() +
               (rest ? rest.charAt(0).toUpperCase() + rest.slice(1).toLowerCase() : '');
      }
      
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

/**
 * Capitalizes first name and last name separately
 * @param {string} firstName - The first name
 * @param {string} lastName - The last name
 * @returns {Object} Object with capitalized first_name and last_name
 */
export const capitalizeNames = (firstName, lastName) => {
  return {
    first_name: capitalizeName(firstName),
    last_name: capitalizeName(lastName)
  };
};
